import React from 'react';
import { useSelectorContext } from './SelectorContext';
import SelectedCapabilityTag from './SelectedCapabilityTag';

import styles from './CapabilitySelector.module.scss';

function flattenSelected(
  capability,
  selectedCapabilities,
  depth = 0,
  idField = 'id'
) {
  const selectedChildren = capability.children.flatMap((c) =>
    flattenSelected(c, selectedCapabilities, depth + 1, idField)
  );

  return capability[idField] in selectedCapabilities
    ? [{ capability, depth }, ...selectedChildren]
    : selectedChildren;
}

function SelectedCapabilities({ idField = 'id' }) {
  const { selectedCapabilities, capabilitySets } = useSelectorContext();

  const onlySelectedCapabilitiesWithinSet =
    capabilitySets?.flatMap((capabilitySet) =>
      capabilitySet?.capabilities?.flatMap((c) =>
        flattenSelected(c, selectedCapabilities, 0, idField)
      )
    ) ?? [];

  return (
    <div className={styles.tags}>
      {onlySelectedCapabilitiesWithinSet.map(({ capability, depth }) => (
        <SelectedCapabilityTag
          key={capability[idField]}
          capability={capability}
          depth={depth}
        />
      ))}
    </div>
  );
}

export default SelectedCapabilities;
